import React from "react";
import "./questionnobox.css";

const Questionnobox = ({ setNextQuestion, nextQuestion, totalResponse }) => {
  return (
    <div className="d-flex align-items-center published_Subject_container">
      {Array(totalResponse)
        .fill()
        .map((_, index) => (
          <div
            key={index}
            onClick={() => setNextQuestion(index)}
            style={{ cursor: "pointer" }}
            className={`numbering_box ${nextQuestion < index
              ? `numbering_box_font`
              : nextQuestion === index && `numbering_box_font_current`
              }`}
          >
            Q{index + 1}
          </div>
        ))}
    </div>
  );
};

export default Questionnobox;
